<div class="row mt-5">
    <div class="col-12 text-center"><h1>{{caption}}...</h1></div>
    <div class="col-12 mt-3 mb-3 text-center">{{subCaption}}</div>
</div>
